import { DialogHeader } from '../../../shared/dialog';
import { Typography } from '@mui/material';
import { styles } from './styles';

export const AudienceDeletionDialogHeader = () => {
  return (
    <DialogHeader>
      <Typography sx={styles.audienceName}>Confirm Deletion</Typography>
      <Typography sx={styles.infoAboutModal}>
        This custom audience has associated posts. Please choose a new audience to ressign these
        posts to.
      </Typography>
    </DialogHeader>
  );
};
